import { useState, useEffect } from "react";
import { content } from "../../data";
import Button from "../Button/Button";
import Copyrights from "../Copyrights/Copyrights";
import { Icon } from "@iconify/react/dist/iconify.js";
import StyledH3Heading from "../../common/components/styledH3Heading/StyledH3Heading";
import StyledH6Heading from "../../common/components/styledH6Heading/StyledH6Heading";

const MobileHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const navItems = content.navItems;

  return (
    <div className="lg:hidden flex items-center">
      <Button
        onClick={toggleMenu}
        variant="gradientButton"
        font="px-1.5 py-1 sm:px-2 sm:py-0 text-white"
      >
        <Icon
          icon={isOpen ? "bitcoin-icons:cross-filled" : "ic:round-menu"}
          width="36"
          height="36"
          className="text-white"
        />
      </Button>

      {/* Mobile Menu Container */}
      <div
        className={`fixed inset-0 top-0 left-0 flex flex-col justify-between bg-black z-50 w-screen h-full transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out`}
        style={{ transition: "all 0.5s cubic-bezier(.68,-0.55,.27,1.55)" }}
      >
        {/* Menu header with logo and close button */}
        <div className="flex justify-center w-full relative p-4">
          {/* LOGO */}
          <div className="w-[170px] min-w-[170px]">
            <a href="/">
              <img
                src="/assets/jaba-logo.svg"
                alt="Jaba Logo"
                className="w-full"
              />
            </a>
          </div>

          {/* Close Button */}
          <div className="w-fit absolute top-5 right-5">
            <Button
              onClick={toggleMenu}
              variant="gradientButton"
              font="p-1 text-white"
            >
              <Icon
                icon="bitcoin-icons:cross-filled"
                width="36"
                height="36"
                className="text-white"
              />
            </Button>
          </div>
        </div>

        {/* Navigation items */}
        <div className="flex flex-col items-center justify-center space-y-8">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.link}
              className={`text-white hover:text-orange transition`}
              onClick={closeMenu} // Close menu when a nav item is clicked
            >
              <StyledH3Heading>{item.title}</StyledH3Heading>
            </a>
          ))}
          <div className="w-1/2 sm:hidden">
            <Button
              variant="gradientButton"
              font="py-2.5 px-5 sm:py-4 sm:px-9 text-white"
            >
              buy now
            </Button>
          </div>
        </div>

        {/* Follow us */}
        <div className="flex flex-col justify-center items-center w-full">
          <div className="flex items-center justify-center gap-6 bg-green w-full py-3">
            <StyledH6Heading font="text-black">Follow us:</StyledH6Heading>

            {/* Social Icons */}
            <div className="flex items-center gap-5">
              <a href="https://telegram.org/">
                <Icon icon="cib:telegram-plane" width="30" height="30" />
              </a>
              <a href="https://twitter.com/">
                <Icon icon="pajamas:twitter" width="27" height="27" />
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="w-full flex justify-center py-5">
            <Copyrights />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileHeader;
